export default __webpack_public_path__ + "static/media/1991.7a47afec.png";